module.exports = __webpack_public_path__ + "static/media/health-program_cb_1.86062f06.png";